/* eslint-disable no-underscore-dangle, no-alert */
import '@fontsource/roboto-condensed/latin-400.css';
import '@fontsource/roboto-condensed/latin-700.css';

import './src/styles/global.styl';
import './src/fonts/style.styl';

const requestPersistentStorage = () => {
    if (navigator.storage && navigator.storage.persist) {
        navigator.storage.persist().catch(() => {
            // Unsupported/denied persistence must not block offline use.
        });
    }
};

export const onServiceWorkerUpdateReady = ({ serviceWorker }) => {
    // A worker may still be activating when Gatsby announces "installed".
    const worker =
        serviceWorker.installing ||
        serviceWorker.waiting ||
        serviceWorker.active;
    const offerReload = () => {
        if (
            window.confirm(
                `Une nouvelle version de l'application est prête (actuelle : ${process.env.__VERSION__}). Relancer pour l'utiliser ?`,
            )
        ) {
            window.location.reload();
        }
    };
    if (!worker) return;
    if (worker.state === 'activated') {
        offerReload();
    } else {
        const onStateChange = () => {
            if (worker.state === 'activated') {
                worker.removeEventListener('statechange', onStateChange);
                offerReload();
            }
        };
        worker.addEventListener('statechange', onStateChange);
    }
};

export const onServiceWorkerActive = requestPersistentStorage;
